import { useAuth } from "@/common/hooks/useAuth";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const auth = useAuth();

  if (auth.status === "loading") {
    return (
      <main className="flex min-h-screen items-center justify-center bg-neutral-950">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-neutral-700 border-t-primary-500" />
      </main>
    );
  }

  if (auth.status === "unauthenticated") return <Navigate to="/login" replace />;

  return <>{children}</>;
}
